<template>
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'450px'"
    :classDialog="'node-dialog'"
    :offsetTop="'25vh'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #body>
      <h3 class="dialogTitle">Thông tin chuyển xử lý</h3>
      <div class="listInfoNode">
        <el-form label-position="right" label-width="120px">
          <el-form-item label="Tên người nhận">
            <el-input
              v-model="process.receiverName"
              placeholder="_"
              size="medium"
              disabled
              class="input-bg__transparent input-font__bold input-border__bottom input-border__radius__0"
            />
          </el-form-item>
          <el-form-item label="Chức vụ: ">
            <el-input
              v-model="process.receiverPosName"
              placeholder="_"
              size="medium"
              disabled
              class="input-bg__transparent input-font__bold input-border__bottom input-border__radius__0"
            />
          </el-form-item>
          <el-form-item label="Đơn vị: ">
            <el-input
              v-model="process.deptReceiverName"
              placeholder="_"
              disabled
              size="medium"
              class="input-bg__transparent input-font__bold input-border__bottom input-border__radius__0"
            />
          </el-form-item>
          <el-form-item label="Thời gian nhận: ">
            <el-input
              :value="convertTimeToString(process.sendTime)"
              placeholder="_"
              disabled
              size="medium"
              class="input-bg__transparent input-font__bold input-border__bottom input-border__radius__0"
            />
          </el-form-item>
          <el-form-item label="Tình trạng xử lý: ">
            <el-input
              :value="processStatusLabel"
              placeholder="_"
              disabled
              size="medium"
              class="input-bg__transparent input-font__bold input-border__bottom input-border__radius__0"
            />
          </el-form-item>
        </el-form>
      </div>
    </template>
  </dialogTemplate>
</template>

<script>
  import dateFormatter from "../../../filters/dateFormatter";
  import constants from "../../../constants";

  export default {
    name: "process-moreinfo-cxlcanhan",
    props: ["isOpen", "process"],
    components: {
      DialogTemplate: () => import("../../common/custom-dialog.vue")
    },
    computed: {
      processStatusLabel() {
        switch (this.process.status) {
          case constants.INCOMING_PROCESS_STATUS.CHO_XU_LY:
            return "Chờ xử lý";
          case constants.INCOMING_PROCESS_STATUS.DA_XU_LY:
            return "Đã xử lý";
          default:
            return "-";
        }
      }
    },
    methods: {
      convertTimeToString(value) {
        return dateFormatter(value);
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/components/process-moreinfo-cxlcanhan.vue